<template>
  <UIMobileBottomNavigation :items="menuItems" :is-visible="isVisible" />
</template>

<script setup lang="ts">
  import { useUserStore } from "~/store/UserModule";
  import { useAdvertStore } from "~/store/AdvertModule";
  import type { MenuItem } from "~/components/UI/MobileBottomNavigation.vue";

  import UINewIconsICart from "~/components/UINew/icons/ICart.vue";
  import UINewIconsIOrders from "~/components/UINew/icons/IOrders.vue";
  import UINewIconsIHeart from "~/components/UINew/icons/IHeart.vue";
  import UINewIconsIMessages from "~/components/UINew/icons/IMessages.vue";

  const userStore = useUserStore();
  const advertStore = useAdvertStore();
  const route = useRoute();

  const isVisible = computed(() => {
    const isAuthorized =
      userStore.authorized && userStore.authorized !== "" && userStore.authorized !== "undefined";
    return !!isAuthorized && route.name !== "index";
  });

  const ordersCount = computed(() => advertStore.ordersCount);
  const activeOrdersCount = computed(() => advertStore.activeOrdersCount);
  const unreadMessagesCount = computed(() => advertStore.unreadMessagesCount);

  onMounted(() => {
    if (isVisible.value) {
      advertStore.fetchSummary();
    }
  });

  watch(isVisible, (val) => {
    if (val) advertStore.fetchSummary();
  });

  watch(
    () => route.path,
    () => {
      if (isVisible.value) advertStore.fetchSummary();
    }
  );

  const menuItems = computed<MenuItem[]>(() => [
    {
      path: "/catalog",
      label: "Каталог",
      icon: UINewIconsICart,
    },
    {
      path: "/orders",
      label: "Заказы",
      icon: UINewIconsIOrders,
      badge: ordersCount.value > 0 ? ordersCount.value : undefined,
      badgeNew: activeOrdersCount.value > 0 ? activeOrdersCount.value : undefined,
      badgeType: "blue",
    },
    {
      path: "/favorites",
      label: "Избранное",
      icon: UINewIconsIHeart,
    },
    {
      path: "/dialogs",
      label: "Диалоги",
      icon: UINewIconsIMessages,
      badge: unreadMessagesCount.value > 0 ? unreadMessagesCount.value : undefined,
      badgeType: "green",
    },
  ]);
</script>
